export default {
    settings: {
        lang: {
            id: 1
        }
    },
    user: null,
    emptyObj: {},
    emptyArr: [],
    playersList: {
        list: [],
        listModalVisible: false,
        isLoading: false
    },
    allowCancel: {
        allowBets: false,
        allowTransaction: false
    }
}